<!--
props:
  [entry|change|...]: 表示画面
  [confirm|..]: ダイアログの種別 confirm=確認
-->
<template>
  <v-dialog
    v-model="show"
    max-width="450"
    persistent
  >
    <v-card>
      <v-card-title class="headline">{{ getTitle }}</v-card-title>
      <v-card-text>{{ getMessage }}</v-card-text>
      <v-card-actions>
        <v-spacer v-if="confirm"></v-spacer>
        <mp-button v-if="confirm" min @click="handleClickCancel">{{ getCancelButtonMessage }}</mp-button>
        <v-spacer></v-spacer>
        <mp-button min @click="handleClickOk">{{ getOkButtonMessage }}</mp-button>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/message'
import MpButton from '@/components/item/MpButton.vue'

export default {
  components: {
    MpButton
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    entry: {
      type: Boolean,
      default: false
    },
    regist: {
      type: Boolean,
      default: false
    },
    modify: {
      type: Boolean,
      default: false
    },
    delete: {
      type: Boolean,
      default: false
    },
    reject: {
      type: Boolean,
      default: false
    },
    approval: {
      type: Boolean,
      default: false
    },
    rejectList: {
      type: Boolean,
      default: false
    },
    approvalList: {
      type: Boolean,
      default: false
    },
    resetList: {
      type: Boolean,
      default: false
    },
    requireSelect: {
      type: Boolean,
      default: false
    },
    reminder: {
      type: Boolean,
      default: false
    },
    mailAddress: {
      type: Boolean,
      default: false
    },
    sendmail: {
      type: Boolean,
      default: false
    },
    confirm: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    }
  },
  data: () => ({
    messageKey: null
  }),
  computed: {
    getTitle () {
      let result = this.title
      if (this.messageKey === null) {
        result = this.title
      } else {
        if (this.$route.path.startsWith('/admin')) {
          result = i18n.t('message.dialog.title.' + this.messageKey, 'ja')
        } else {
          result = i18n.t('message.dialog.title.' + this.messageKey)
        }
      }
      return result
    },
    getMessage () {
      let result = this.title
      if (this.messageKey === null) {
        result = this.message
      } else {
        if (this.$route.path.startsWith('/admin')) {
          result = i18n.t('message.dialog.desc.' + this.messageKey, 'ja')
        } else {
          result = i18n.t('message.dialog.desc.' + this.messageKey)
        }
      }
      return result
    },
    getOkButtonMessage () {
      let result = ''
      if (this.$route.path.startsWith('/admin')) {
        result = i18n.t('message.dialog.button.ok', 'ja')
      } else {
        result = i18n.t('message.dialog.button.ok')
      }
      return result
    },
    getCancelButtonMessage () {
      let result = ''
      if (this.$route.path.startsWith('/admin')) {
        result = i18n.t('message.dialog.button.cancel', 'ja')
      } else {
        result = i18n.t('message.dialog.button.cancel')
      }
      return result
    }
  },
  methods: {
    // OKクリック時
    handleClickOk (ev) {
      // 親のclickOkを呼び出し
      this.$emit('clickOk', ev)
    },
    // キャンセルクリック時
    handleClickCancel (ev) {
      // 親のclickCancelを呼び出し
      this.$emit('clickCancel', ev)
    }
  },
  created () {
    // パターン別にメッセージキーを設定
    if (this.entry && !this.confirm) {
      // 申請完了
      this.messageKey = 'entryComplete'
    } else if (this.regist && !this.confirm) {
      // 登録完了
      this.messageKey = 'registComplete'
    } else if (this.modify && this.confirm) {
      // 変更確認
      this.messageKey = 'modifyConfirm'
    } else if (this.modify && !this.confirm) {
      // 変更完了
      this.messageKey = 'modifyComplete'
    } else if (this.delete && this.confirm) {
      // 削除確認
      this.messageKey = 'deleteConfirm'
    } else if (this.delete && !this.confirm) {
      // 削除完了
      this.messageKey = 'deleteComplete'
    } else if (this.reject && this.confirm) {
      // 却下確認（1件）
      this.messageKey = 'rejectConfirm'
    } else if (this.reject && !this.confirm) {
      // 却下完了（1件）
      this.messageKey = 'rejectComplete'
    } else if (this.approval && this.confirm) {
      // 承認確認（1件）
      this.messageKey = 'approvalConfirm'
    } else if (this.approval && !this.confirm) {
      // 承認完了（1件）
      this.messageKey = 'approvalComplete'
    } else if (this.rejectList && this.confirm) {
      // 却下確認（N件）
      this.messageKey = 'rejectListConfirm'
    } else if (this.rejectList && !this.confirm) {
      // 却下完了（N件）
      this.messageKey = 'rejectListComplete'
    } else if (this.approvalList && this.confirm) {
      // 承認確認（N件）
      this.messageKey = 'approvalListConfirm'
    } else if (this.approvalList && !this.confirm) {
      // 承認完了（N件）
      this.messageKey = 'approvalListComplete'
    } else if (this.resetList && this.confirm) {
      // パスワードリセット確認（N件）
      this.messageKey = 'resetListConfirm'
    } else if (this.resetList && !this.confirm) {
      // パスワードリセット完了（N件）
      this.messageKey = 'resetListComplete'
    } else if (this.requireSelect && !this.confirm) {
      // 'アカウント選択エラー'
      this.messageKey = 'requireSelect'
    } else if (this.reminder && !this.confirm) {
      // パスワード再発行完了
      this.messageKey = 'reminderComplete'
    } else if (this.sendmail && !this.confirm) {
      // メール一斉配信完了
      this.messageKey = 'sendMailComplete'
    }
  }
}
</script>

<style scoped>
</style>
